module.exports = __webpack_public_path__ + "img/pic2.3bf54c28.png";